import { NBSP } from 'shared/constants/symbols';
import { EDealType, EOfferType, type TPageType } from 'shared/types/features';

import { getStepsWord } from './getStepsWord';

type TGetStepsMainTitleParams = {
  pageType: TPageType;
  stepsCount: number;
  dealType?: EDealType | null;
  offerType?: EOfferType | null;
};

const DEAL_TYPE_LABELS: Record<EDealType, string> = {
  [EDealType.Sale]: 'продаже',
  [EDealType.Rent]: 'аренде',
};

const OFFER_TYPE_LABELS: Record<EOfferType, string> = {
  [EOfferType.Apartment]: 'квартиры',
  [EOfferType.Suburban]: 'дома',
};

export const getStepsMainTitle = ({ pageType, stepsCount, dealType, offerType }: TGetStepsMainTitleParams): string => {
  const stepsWord = getStepsWord(stepsCount);

  if (pageType === 'smb') {
    return `${stepsCount} ${stepsWord} к эффективному размещению на${NBSP}Циан`;
  }

  const offerLabel = offerType ? OFFER_TYPE_LABELS[offerType] : OFFER_TYPE_LABELS[EOfferType.Apartment];

  if (pageType === 'host') {
    return `${stepsCount} ${stepsWord} к сдаче ${offerLabel} посуточно`;
  }

  const dealLabel = dealType ? DEAL_TYPE_LABELS[dealType] : DEAL_TYPE_LABELS[EDealType.Sale];

  return `${stepsCount} ${stepsWord} к ${dealLabel} ${offerLabel}`;
};
